import { jsxs as c, jsx as h } from "react/jsx-runtime";
const v = (l) => /* @__PURE__ */ c(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...l,
    children: [
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "M21.02 51.068a1.998 1.998 0 1 0 0-3.996 1.998 1.998 0 0 0 0 3.996ZM30.073 20.217l-1.168-4.408s-7.098 7.458-7.839 12.421c-.532 3.563 1.54 7.961 7.84 7.961h.104c.026 0 .053 0 .081-.002 7.22-.08 8.358-4.772 7.834-8.241-.59-3.91-5.604-9.08-5.604-9.08l-1.248 1.35Zm.61 13.412c-.602.395-1.296.543-1.605.562-.034 0-.068 0-.102.002-.29-.011-1.012-.154-1.638-.564-.798-.522-.9-1.128-.9-1.596 0-.72.602-1.74 1.651-2.797a13.4 13.4 0 0 1 .921-.841c.288.24.607.524.921.842 1.05 1.058 1.652 2.077 1.652 2.797 0 .468-.101 1.073-.9 1.596Zm3.36-1.134a3.72 3.72 0 0 1-.586.545 4.04 4.04 0 0 0 .124-1.007c0-3.169-4.57-6.138-4.57-6.138s-4.572 2.968-4.572 6.138c0 .29.028.562.08.817a4.343 4.343 0 0 1-.441-.439c-.863-1-1.25-2.454-1.037-3.886.25-1.671 1.597-4.204 3.795-7.134.376-.502.75-.98 1.106-1.419l.2.756.93 3.512 2.215-2.393c1.476 1.795 3.371 4.467 3.663 6.4.357 2.366-.414 3.677-.906 4.248Z"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "M32.867 53.976H13.028a.051.051 0 0 1-.013-.012v-9.978h18.058a12.99 12.99 0 0 1 .62-1.997H13.014V10.024H44.98v23.762c1.406.119 2.75.46 3.995.988V6.029H13.011a3.993 3.993 0 0 0-3.993 3.992v43.935a4.016 4.016 0 0 0 4.016 4.015h23.897a13.223 13.223 0 0 1-4.064-3.995Z"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "M43.868 35.737c-6.138 0-11.114 4.975-11.114 11.113 0 6.139 4.976 11.114 11.114 11.114 6.138 0 11.113-4.975 11.113-11.114 0-6.138-4.975-11.113-11.113-11.113Zm0 19.23c-4.476 0-8.117-3.64-8.117-8.117 0-4.476 3.64-8.117 8.117-8.117 4.476 0 8.117 3.642 8.117 8.117 0 4.477-3.641 8.117-8.117 8.117Z"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "M43.27 43.724v-.763h-2.996v.763h-1.275v1.997h1.275v.761h2.996v-.76h5.737v-1.998h-5.736ZM47.734 47.662h-2.996v.762h-5.739v1.998h5.739v.761h2.996v-.76h1.273v-1.999h-1.273v-.762Z"
        }
      )
    ]
  }
);
export {
  v as BoilerReplacement
};
